export enum ClaimGroupMessages {
  concreteBatchingPlant = "claimGroup.concreteBatchingPlant",
  gravel = "claimGroup.gravel",
  supply = "claimGroup.supply",
  characteristic = "claimGroup.characteristic",
  classification = "claimGroup.classification",
  supplier = "claimGroup.supplier",
  concreteBatchingPlantGroup = "claimGroup.concreteBatchingPlantGroup",
  productGroup = "claimGroup.productGroup",
  concreteRecipe = "claimGroup.concreteRecipe",
  concreteBatchingPlantRegional = "claimGroup.concreteBatchingPlantRegional",
  slump = "claimGroup.slump",
  measureUnitType = "claimGroup.measureUnitType",
  technicalDataSupply = "claimGroup.technicalDataSupply",
  costSupply = "claimGroup.costSupply",
  abramsCurve = "claimGroup.abramsCurve",
  concreteRecipeFamily = "claimGroup.concreteRecipeFamily",
  copyInBatch = "claimGroup.copyInBatch",
  changeInBatch = "claimGroup.changeInBatch",
  userRightsControl = "claimGroup.userRightsControl",
  externalId = "claimGroup.externalId",
  csvImport = "claimGroup.csvImport",
  concreteMixDesignSheet = "claimGroup.concreteMixDesignSheet",
  concreteMixDesignSheetParameters = "claimGroup.concreteMixDesignSheetParameters",
  aggregateTest = "claimGroup.aggregateTest",
  aggregateTestReport = "claimGroup.aggregateTestReport",
  sieve = "claimGroup.sieve",
  responsibleEngineer = "claimGroup.responsibleEngineer",
  laboratory = "claimGroup.laboratory",
  laboratoryTechnician = "claimGroup.laboratoryTechnician",
  standard = "claimGroup.standard",
  integrations = "claimGroup.integrations",
  vehicles = "claimGroup.vehicles",
  employees = "claimGroup.employees",
  reports = "claimGroup.reports",
  generalParameters = "claimGroup.generalParameters",
  expedition = "claimGroup.expedition",
  aggregateMoisture = "claimGroup.aggregateMoisture",
  loadTickets = "claimGroup.loadTickets",
  deliveriesTickets = "claimGroup.deliveriesTickets",
  loadReuse = "claimGroup.loadReuse",
  invoices = "claimGroup.invoices",
  weighingLink = "claimGroup.weighingLink",
  inventory = "claimGroup.inventory",
  inventoryClosure = "claimGroup.inventoryClosure",
  dailyClosing = "claimGroup.dailyClosing",
  invoiceStub = "claimGroup.invoiceStub",
  approvalOfAdditionalFees = "claimGroup.approvalOfAdditionalFees",
  schedulings = "claimGroup.schedulings",
  concreteBatchingPlantGroupDispatch = "claimGroup.concreteBatchingPlantGroupDispatch",
  concreteBatchingPlantRegionalDispatch = "claimGroup.concreteBatchingPlantRegionalDispatch",
  delivery = "claimGroup.delivery",
  reservation = "claimGroup.reservation",
  concreteBatchingPlantsDispatch = "claimGroup.concreteBatchingPlantsDispatch",
  concreteBatchingPlantGeneralParameters = "claimGroup.concreteBatchingPlantGeneralParameters",
  concreteBatchingPlantOpeningHoursParameters = "claimGroup.concreteBatchingPlantOpeningHoursParameters",
  concreteBatchingPlantAverageDurationParameters = "claimGroup.concreteBatchingPlantAverageDurationParameters",
  concreteBatchingPlantMoldingParameters = "claimGroup.concreteBatchingPlantMoldingParameters",
  concreteBatchingPlantDailyClosingParameters = "claimGroup.concreteBatchingPlantDailyClosingParameters",
  concreteBatchingPlantTaxDocumentParameters = "claimGroup.concreteBatchingPlantTaxDocumentParameters",
  loadingPoints = "claimGroup.loadingPoints",
  loadingPointLocations = "claimGroup.loadingPointLocations",
  deliveryRoutes = "claimGroup.deliveryRoutes",
  pumpingTypes = "claimGroup.pumpingTypes",
  piecesToBeConcreted = "claimGroup.piecesToBeConcreted",
  defaultDurationsByPumpingType = "claimGroup.defaultDurationsByPumpingType",
  holidays = "claimGroup.holidays",
  reasons = "claimGroup.reasons",
  taxConfigurationConcreteRecipe = "claimGroup.taxConfigurationConcreteRecipe",
  users = "claimGroup.users",
  groups = "claimGroup.groups",
  alerts = "claimGroup.alerts",
  concreteDiscardDestination = "claimGroup.concreteDiscardDestination",
  loadTicketBlockReason = "claimGroup.loadTicketBlockReason",
  pumpingBlockReason = "claimGroup.pumpingBlockReason",
  dailyProductionClosingInconsistencies = "claimGroup.dailyProductionClosingInconsistencies",
  batchMaintenanceView = "claimGroup.batchMaintenanceView",
  batchMaintenanceEdit = "claimGroup.batchMaintenanceEdit",
  batchMaintenanceExecute = "claimGroup.batchMaintenanceExecute",
  batchAutomationView = "claimGroup.batchAutomationView",
  batchAutomationExecute = "claimGroup.batchAutomationExecute",
  batchAutomationAdmin = "claimGroup.batchAutomationAdmin",
  batchAutomationSuperAdmin = "claimGroup.batchAutomationSuperAdmin",
  timeRecords = "claimGroup.timeRecords",
  timeClockConfigurations = "claimGroup.timeClockConfigurations",
  performance = "claimGroup.performance",
  laboratoryModule = "claimGroup.laboratoryModule",
  specimenCollection = "claimGroup.specimenCollection",
  specimenRupture = "claimGroup.specimenRupture",
  deliveryTicketSpecimens = "claimGroup.deliveryTicketSpecimens",
  collectionSchedule = "claimGroup.collectionSchedule",
  ruptureSchedule = "claimGroup.ruptureSchedule",
  issueCertificate = "claimGroup.issueCertificate",
  issuedCertificates = "claimGroup.issuedCertificates",
  presses = "claimGroup.presses",
  certificateParameters = "claimGroup.certificateParameters",
  laboratoryStatistics = "claimGroup.laboratoryStatistics",
  lowStrengthApproval = "claimGroup.lowStrengthApproval"
}

export type TranslationClaimGroupMessages = {
  [key in ClaimGroupMessages]: string;
}
